/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import { axios } from 'api'
import { Product } from 'hooks/useProduct'

type UseSearchProductsParams = {
  keyword: string
  initialPage?: number
  limit?: number
}

const useSearchProducts = ({
  keyword,
  initialPage = 1,
  limit = 8
}: UseSearchProductsParams) => {
  const [products, setProducts] = useState<Product[]>([])
  const [currentPage, setCurrentPage] = useState<number>(initialPage as number)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [totalItems, setTotalItems] = useState<number>(0)
  const searchProducts = async (keyword: string, page = 1) => {
    const response = await axios.get(
      `/products/search?keyword=${encodeURIComponent(
        keyword
      )}&page=${page}&limit=${limit}`
    )

    if (response.status === 200) {
      setProducts(response.data.products)
      setCurrentPage(response.data.currentPage)
      setTotalPages(response.data.totalPages)
      setTotalItems(response.data.totalItems)
    } else {
      console.error('Failed to fetch products.')
    }
  }

  // Search is driven by the query and current page.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    searchProducts(keyword, currentPage)
  }, [keyword, currentPage])

  return {
    products,
    currentPage,
    totalPages,
    totalItems,
    setCurrentPage,
    searchProducts
  }
}

export default useSearchProducts
